import React from 'react';

import { Wrapper } from './Wrapper';
import { Overlay } from './Overlay';
import { BaseBirdContrast } from '../../svg';
import { TestIconContainer } from './TestIconContainer';

interface IProps {
    fadePercentage: number;
    style: React.CSSProperties;
}

export const ContrastDisplay: React.FC<IProps> = ({
    fadePercentage,
    style,
}) => (
    <Wrapper style={{ ...style }}>
        <Overlay fadePercentage={fadePercentage} />
        <TestIconContainer>
            <BaseBirdContrast />
        </TestIconContainer>
    </Wrapper>
);
